module.exports = __webpack_public_path__ + "media/images/logos/rpf-logo-with-bg-3eecdc117c49c1457d7431ea417f5a2b.svg";